import { render, staticRenderFns } from "./Test9.vue?vue&type=template&id=7d85cf4a&"
import script from "./Test9.vue?vue&type=script&lang=js&"
export * from "./Test9.vue?vue&type=script&lang=js&"
import style0 from "./Test9.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports